import {
  DesignTokenSizeEnum,
  styled,
} from '@volkswagen-onehub/components-core';
import { convertBreakpointsToMediaQueries } from '@/modules/utils/themeUtils';

export const StyledFeatureCardsSection = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.size[DesignTokenSizeEnum.static350]};

    ${convertBreakpointsToMediaQueries({
      b960: {
        gap: theme.size[DesignTokenSizeEnum.static515],
      },
    })}
    `
);
